import DuplicateMap from "../../../../components/DataCollection/Unifier/Maps/DuplicateMap/DuplicateMap"

const DuplicateMapsScreen = () => {
  return (
    <DuplicateMap/>
  )
}

export default DuplicateMapsScreen